import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = { class: "c-scroll-bar-hide overflow-x-scroll grid grid-flow-col gap-16" }
const _hoisted_4 = { class: "w-2/3 text-center mx-auto mt-gutter pb-1 mb-1 xl:w-1/2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col md:flex-row"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "mb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _component_IndicatorsForNativeHorizontalScroll = _resolveComponent("IndicatorsForNativeHorizontalScroll")!

  return (_ctx.content.tiles.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.showCarousel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.tiles, (section) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.model.title,
                    class: "min-w-screen-80 flex-no-shrink mb-gutter mr-10"
                  }, [
                    _createVNode(_component_MediaHandler, {
                      "media-block": section.model.media,
                      "media-aspect-ratio": _ctx.aspectRatioWithCarousel,
                      "video-disable-on-mobile": _ctx.content.disableVideoOnMobile,
                      class: "w-full h-full"
                    }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"]),
                    _createElementVNode("div", _hoisted_4, [
                      (section.model.subheading)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "o-text-caption uppercase m-0",
                            innerHTML: section.model.subheading
                          }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true),
                      (section.model.title)
                        ? (_openBlock(), _createElementBlock("h2", {
                            key: 1,
                            class: "mb-10",
                            innerHTML: section.model.title
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      (section.model.text)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(section.model.text), 1))
                        : _createCommentVNode("", true),
                      (section.model.link)
                        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
                            key: 3,
                            class: "mt-15",
                            "link-block": section.model.link,
                            "style-as-button": !_ctx.content.alternativeLinkStyle
                          }, null, 8, ["link-block", "style-as-button"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_IndicatorsForNativeHorizontalScroll, {
                "quantity-off-scroll-elements": _ctx.content.tiles.length
              }, null, 8, ["quantity-off-scroll-elements"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.tiles, (section, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.model.title,
                  class: _normalizeClass([{'mb-gutter md:mb-0 md:mr-15': index !== _ctx.content.tiles.length - 1 }, "w-full"])
                }, [
                  _createVNode(_component_MediaHandler, {
                    "media-block": section.model.media,
                    "media-aspect-ratio": _ctx.aspectRatioWithoutCarousel,
                    "video-disable-on-mobile": _ctx.content.disableVideoOnMobile
                  }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-center mx-auto my-gutter w-4/5", {width: 100 / _ctx.content.tiles.length + '%'}])
                  }, [
                    (section.model.subheading)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "o-text-caption uppercase m-0",
                          innerHTML: section.model.subheading
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (section.model.title)
                      ? (_openBlock(), _createElementBlock("h2", {
                          key: 1,
                          class: "mb-10",
                          innerHTML: section.model.title
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (section.model.text)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(section.model.text), 1))
                      : _createCommentVNode("", true),
                    (section.model.link)
                      ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
                          key: 3,
                          class: "mt-15",
                          "link-block": section.model.link,
                          "style-as-button": !_ctx.content.alternativeLinkStyle
                        }, null, 8, ["link-block", "style-as-button"]))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 2))
              }), 128))
            ]))
      ]))
    : _createCommentVNode("", true)
}